import { Inject, Injectable } from "@angular/core";
import { DwDataItemKeyValues, DwDataRequest, DwDatasource, DwMetaDataService, DwMetaDataServiceToken, DwOrmDataService, DwOrmDataServiceToken, DwOrmDataSource, DwQuery, DwQueryHavingFilterHelper, DwQueryHelper } from "@devwareapps/devware-cap";
import { Observable } from "rxjs";
import { ProjectKickoffMetaDataItemNames, ProjectKickoffMetaData } from "../meta-data/projectkickoff-meta-data.service";

@DwDatasource({
    keyName: 'ProjectKickoffDataSource',
    display: 'Projects Kickoff - Form Data Source',
    itemName: ProjectKickoffMetaDataItemNames.ProjectsKickoff,
})
@Injectable()
export class ProjectKickoffFormDataSourceService extends DwOrmDataSource {

    constructor(
        @Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
        @Inject(DwMetaDataServiceToken) metaDataService: DwMetaDataService,
    ) {
        super(dwOrmDataService, metaDataService, ProjectKickoffMetaDataItemNames.ProjectsKickoff);
    }

    initDataSource() {
            
    }


    protected loadItemFromQuery(query: DwQuery, keyValues: DwDataItemKeyValues | number): Observable<any> {
        
        const prefetch = query.Prefetch?.find(p => p.RelationName == ProjectKickoffMetaData.ProjectsKickoff.Relations.Billing.relationName);

        if (prefetch) {
            const subQuery = ProjectKickoffMetaData.Billing.CreateQueryBuilder();

            subQuery.setFieldSettings(s => s.LoadAllLookupDisplayFields = true);

            subQuery.addPrefetch(r => r.BillingDepartment);

            prefetch.Query = subQuery.query;
        }
    
        return super.loadItemFromQuery(query, keyValues);
    }

}